import { defineComponent, openBlock, createElementBlock, createVNode, unref, createTextVNode } from "@histoire/vendors/vue";
import { Icon } from "@histoire/vendors/iconify";
"use strict";
const _hoisted_1 = { class: "histoire-search-loading htw-flex htw-items-center htw-gap-4 htw-pl-6 htw-border htw-border-transparent focus-visible:htw-border-primary-500 htw-h-[51px] htw-opacity-30" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SearchLoading",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(unref(Icon), {
          icon: "carbon:search",
          class: "flex-none htw-w-4 htw-h-4"
        }),
        createTextVNode(" Loading... ")
      ]);
    };
  }
});
export {
  _sfc_main as default
};
